import { api } from '@/boot/axios'
import { getAuthToken } from '@/boot/axios'
import type { User, UserDetail, UserCompany, Notification, UserEducation, CreateUserLink, NotificationSettings } from '@/interfaces'
import { ElMessage } from 'element-plus'

export function useUser() {

  const getUserDetail = async () => {
    try {
      const response = await api.get<UserDetail>('/auth/me/detail', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return undefined
    }
  }

  const getUserContacts = async () => {
    try {
      const response = await api.get<User[]>('/user/contacts', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getFavouriteResidents = async () => {
    try {
      const response = await api.get<User[]>('/user/favourite-residents', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getMatchingUserCompanies = async () => {
    try {
      const response = await api.get<UserCompany[]>('/user/company/matching/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getNotificationList = async () => {
    try {
      const response = await api.get<Notification[]>('/notification/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const updateUserInfo = async (data: FormData) => {
    try {
      await api.patch('/user/edit', data, {
        headers: {
          'Authorization': getAuthToken(),
          'Content-Type': 'multipart/form-data'
        }
      })
      ElMessage.success('Данные успешно обновлены')
    } catch (er) {
      console.error(er)
      ElMessage.error('Не удалось обновить данные')
    }
  }

  const uploadNewCompany = async (data: FormData) => {
    try {
      await api.post('/user/company/create', data, {
        headers: {
          'Authorization': getAuthToken(),
          'Content-Type': 'multipart/form-data'
        }
      })
      ElMessage.success('Компания успешно добавлена')
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const deleteCompany = async (companyId: number) => {
    try {
      await api.delete(`/user/company/${companyId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      ElMessage.success('Компания успешно удалена')
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const updateCompany = async (companyId: number, data: FormData) => {
    try {
      await api.put(`/user/company/${companyId}`, data, {
        headers: {
          'Authorization': getAuthToken(),
          'Content-Type': 'multipart/form-data'
        }
      });
      ElMessage.success('Компания успешно обновлена');
    } catch (er) {
      console.error(er);
      ElMessage.error('Ошибка при обновлении компании');
    }
  };

  const getCompanyDetail = async (companyId: number) => {
    try {
      const response = await api.get<UserCompany>(`/user/company/${companyId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return undefined
    }
  }

  const createEducation = async (data: UserEducation) => {
    try {
      await api.post('/user/education/create', data, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      ElMessage.success('Образование успешно добавлено')
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const deleteEducation = async (educationId: number) => {
    try {
      await api.delete(`/user/education/${educationId}/delete`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      ElMessage.success('Запись удалена')
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const createLink = async (data: CreateUserLink) => {
    try {
      await api.post('/user/link/create', data, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const deleteLink = async (linkId: number) => {
    try {
      await api.delete(`/user/link/${linkId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const toggleNotificationSetting = async (data: NotificationSettings) => {
    try {
      await api.patch('/user/settings/notification', data, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      ElMessage.success('Настройки успешно изменены')
    } catch (er) {
      console.error(er)
      ElMessage.error('Ошибка сервера')
    }
  }

  const getUserTariff = async () => {
    try {
      const response = await api.get('/user/tariff', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
    }
  }

  const stopUserTariff = async () => {
    try {
      await api.post('/user/tariff/stop', {}, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
    } catch (er) {
      console.error(er)
    }
  }


  return {
    getUserDetail,
    getUserContacts,
    getFavouriteResidents,
    getMatchingUserCompanies,
    getNotificationList,
    updateUserInfo,
    uploadNewCompany,
    deleteCompany,
    updateCompany,
    getCompanyDetail,
    createEducation,
    deleteEducation,
    createLink,
    deleteLink,
    toggleNotificationSetting,
    getUserTariff,
    stopUserTariff
  }
}